import { BookingCurrency } from '~/types/booking'

export interface Donation {
  donationAmount: number
  donationCurrency: BookingCurrency
  donationType: DonationType
}

export interface DonationErrors {
  donationAmount: string
  donationCurrency: string
  donationType: string
}

export enum DonationType {
  ONE_TIME = 'one-time',
  RECURRING = 'recurring',
}

export interface donationSliceStates {
  donationDetails: Donation
  donationDetailsErrors: DonationErrors
}
